/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuItems from "./MenuItems";
import MenuItemsOnePage from "./MenuItemsOnePage";
import { PatientAuthContext } from "../../contexts/PatientAuthContext";

import LogoWhite from "../../assets/img/logo/logo-white-4.png";

const HeaderFour = (props) => {
  const { headerClass, headerLogo, isOnePage } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { patient, logout } = useContext(PatientAuthContext);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      <header className={headerClass ? headerClass : ""}>
        <div className="it-header-top-area it-header-top-style-2">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xxl-5 col-xl-4 col-lg-3 col-md-4">
                <div className="it-header-top__left d-flex align-items-center">
                  {patient ? (
                    <div className="d-none d-md-flex align-items-center gap-2">
                      {/* Avatar circle */}
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.2)",
                          border: "1.5px solid rgba(255,255,255,0.5)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.7rem",
                          fontWeight: 800,
                          color: "#fff",
                          flexShrink: 0,
                        }}
                      >
                        {patient.firstName ? patient.firstName.charAt(0).toUpperCase() : patient.mrno?.charAt(0)}
                      </div>
                      <span style={{ color: "rgba(255,255,255,0.9)", fontWeight: 600, fontSize: "0.82rem" }}>
                        {patient.firstName ? `${patient.firstName} ${patient.lastName || ""}`.trim() : `MR# ${patient.mrno}`}
                      </span>
                      <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.7rem" }}>·</span>
                      <Link
                        to="/patient-profile"
                        style={{
                          color: "rgba(255,255,255,0.75)",
                          fontSize: "0.78rem",
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <i className="fa-regular fa-user" style={{ fontSize: 10 }} /> My Profile
                      </Link>
                      <span style={{ color: "rgba(255,255,255,0.3)", fontSize: "0.7rem" }}>·</span>
                      <button
                        onClick={logout}
                        style={{
                          background: "none",
                          border: "none",
                          color: "rgba(255,255,255,0.65)",
                          cursor: "pointer",
                          fontSize: "0.78rem",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <i className="fa-regular fa-arrow-right-from-bracket" style={{ fontSize: 10 }} /> Logout
                      </button>
                    </div>
                  ) : (
                    <div className="d-none d-md-flex align-items-center gap-2">
                      <Link
                        to="/patient-login"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          color: "#fff",
                          fontSize: "0.8rem",
                          fontWeight: 600,
                          padding: "5px 14px",
                          border: "1.5px solid rgba(255,255,255,0.55)",
                          borderRadius: 999,
                          textDecoration: "none",
                          transition: "background .2s, border-color .2s",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.12)")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                      >
                        <i className="fa-regular fa-user" style={{ fontSize: 11 }} />
                        Login
                      </Link>
                      <Link
                        to="/appointment"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          color: "#0d3b6e",
                          fontSize: "0.8rem",
                          fontWeight: 700,
                          padding: "5px 14px",
                          background: "#fff",
                          border: "1.5px solid #fff",
                          borderRadius: 999,
                          textDecoration: "none",
                          transition: "opacity .2s",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
                        onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                      >
                        <i className="fa-regular fa-calendar-check" style={{ fontSize: 11 }} />
                        Book Appointment
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xxl-7 col-xl-8 col-lg-9 col-md-8">
                <div className="it-header-top-content text-center text-md-end">
                  <ul>
                    <li>
                      <div>
                        <a href="tel:+92-51-111-644-911">
                          <i className="flaticon-call"></i>
                          <span className="hover-anim white">24/7 Emergency: 111-644-911</span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div>
                        <a href="mailto:info@maroof.com.pk">
                          <i className="flaticon-letter"></i>
                          <span className="hover-anim white">info@maroof.com.pk</span>
                        </a>
                      </div>
                    </li>
                    <li className="d-none d-lg-inline-block">
                      <div>
                        <a
                          target="_blank"
                          href="https://www.google.com/maps/place/Maroof+International+Hospital/@33.6974641,73.0090763,17z/data=!3m1!4b1!4m6!3m5!1s0x38dfbe6b77fc7279:0x855a61d1ef5e9def!8m2!3d33.6974597!4d73.0116512!16s%2Fg%2F1hdzv62pm!5m2!1e4!1e1?entry=ttu&g_ep=EgoyMDI2MDMyNC4wIKXMDSoASAFQAw%3D%3D"
                          rel="noreferrer"
                        >
                          <i className="flaticon-location"></i>
                          <span className="hover-anim white">F-10 Markaz, ISB, PK</span>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="header-sticky"
          className={
            isVisible
              ? "it-header-area it-header-ptb it-header-style-3 it-header-style-6 white-bg header-sticky"
              : "it-header-area it-header-ptb it-header-style-3 it-header-style-6 white-bg"
          }
        >
          <div className="container">
            <div className="p-relative">
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-6 col-6">
                  <div className="it-header-logo">
                    <Link to="/">
                      <img src="images/logo/logo-full.png" alt="" />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-10 d-none d-xl-block">
                  <div className="it-header-main-menu it-main-menu">
                    <nav className="it-menu-content">{!isOnePage ? <MenuItems /> : <MenuItemsOnePage onePageStyle="onePage4" />}</nav>
                  </div>
                </div>
                <div className="col-lg-6 col-6 d-xl-none">
                  <div style={{ padding: 4 }} className="it-header-button d-flex align-items-center justify-content-end">
                    <div className="it-header-bar">
                      <button className="it-menu-bar" onClick={() => setIsOffCanvasOpen(true)}>
                        <span>
                          <i className="fa-regular fa-bars-sort"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? "itoffcanvas opened" : "itoffcanvas"}>
          <div className="itoffcanvas__close-btn">
            <button className="close-btn" onClick={() => setIsOffCanvasOpen(false)}>
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={LogoWhite} alt="" />
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>Suspendisse interdum consectetur libero id. Fermentum leo vel orci porta non. Euismod viverra nibh cras pulvinar suspen.</p>
          </div>
          <div className="it-menu-mobile">
            {!isOnePage ? <MenuItems isMobileMenu /> : <MenuItemsOnePage onePageStyle="onePage4" isMobileMenu />}
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get In Touch</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="maito:hello@yourmail.com">hello@yourmail.com</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">(00) 456 1122 7890</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a href="htits://www.google.com/maps/@37.4801311,22.8928877,3z" target="_blank" rel="noreferrer">
                  Riverside 255, San Francisco, USA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen ? (
        <div className="body-overlay apply" onClick={() => setIsOffCanvasOpen(false)}></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default HeaderFour;
